import categoriesEndpoint from './categories';
import productsEndpoint from './products';
import productMetadatas from './productMetadatas';

export default {
    categoriesEndpoint, productsEndpoint, productMetadatas
}